query ListScheduledAccountDeletions {
  rows: StreamToolsListScheduledAccountDeletions {
    accountId
    status
    requestedAt
    runAt
    requestedByMe
    staffAccount
    wasSuspended
    accountExists
    email
    heldReason
    stopReason
    stoppedAt
  }
}
